module.exports = __webpack_public_path__ + "img/full1-min.448341f1.png";